import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=e061c382&scoped=true&"
import script from "./ErrorOverlay.vue?vue&type=script&lang=js&"
export * from "./ErrorOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOverlay.vue?vue&type=style&index=0&id=e061c382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061c382",
  null
  
)

component.options.__file = "ErrorOverlay.vue"
export default component.exports